export enum PersistenceKeys {
  COLUMNS = 'columns',
}

export type PersistedColumn = {
  name: string
  visible: boolean
  width?: number
}

export type MergeStrategy<T> = (stored: T[], initial: T[]) => T[]
